import { useEffect, useRef } from 'react';

export const useResizeObserver = <T extends HTMLElement>(
  onResize: (entries: ResizeObserverEntry[]) => void
) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      onResize([]);
      return;
    }

    const resizeObserver = new ResizeObserver(onResize);

    resizeObserver.observe(element);
    return () => {
      resizeObserver.disconnect();
      onResize([]);
    };
  }, [onResize]);

  return ref;
};
